import { Component } from '@angular/core';
import { BankingAccountTypeService } from '../banking-account-type.service';
import { BankingAccountType } from '../banking-account-type';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../../../shared/notification.service';

@Component({
  selector: 'app-banking-account-type-edit',
  templateUrl: 'edit.component.html',
})
export class BankingAccountTypeEditComponent {
  /**
   * Details of the accountType being edited.
   */
  public accountType: BankingAccountType;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {BankingAccountTypeService} accountTypeService
   * @param {NotificationService} notificationService
   * @param {Router} router
   * @param {ActivatedRoute} route
   */
  constructor(
    private accountTypeService: BankingAccountTypeService,
    private notificationService: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.accountTypeService.loading.subscribe(
      result => (this.isLoading = result),
    );
    this.route.params.subscribe(params => this.loadBankingAccountType(params.id));
  }

  /**
   * Perform the edit action which send the edited accountType to the backend.
   */
  public edit() {
    const editBankingAccountType = this.accountTypeService
      .updateBankingAccountType(this.accountType.id, this.accountType)
      .subscribe(
        (result: BankingAccountType) => {
          this.notificationService.success(
            `Account Type Updated`,
            `The account Type ${
              result.name
            } been updated with the specified changes.`,
            5,
          );
          this.accountType = new BankingAccountType();
          editBankingAccountType.unsubscribe();
          this.router.navigate(['/banking/account-types']);
        },
        err => {
          this.notificationService.error(
            `Account Type Not Found`,
            err.error.message,
            10,
          );
          this.router.navigate(['/banking/account-types']);
        },
      );
  }

  /**
   * Loads the requested accountType so we can display it and let the user edit the fields.
   *
   * @param {string} id
   */
  private loadBankingAccountType(id: string) {
    this.accountTypeService.findBankingAccountType(id).subscribe(
      result => {
        this.accountType = result;
      },
      err => {
        this.notificationService.error(
          `Account Type Not Found`,
          err.error.message,
          10,
        );
        this.router.navigate(['/banking/account-types']);
      },
    );
  }
}
